import { Navigate, type Params, useLocation, useParams } from "react-router";
import { getLastChatAgent } from "./lastChatAgent";

/**
 * Sends a moved URL to its new home, carrying the query string and hash along:
 * a bookmarked filter or a hand-off (`/playground/:slug?conversation=`) must
 * survive the move, which a bare `<Navigate>` would drop.
 */
export function MovedRoute({
	to,
}: {
	to: string | ((params: Params, search: URLSearchParams) => string);
}) {
	const params = useParams();
	const { search, hash } = useLocation();
	const pathname = typeof to === "string" ? to : to(params, new URLSearchParams(search));
	return <Navigate to={{ pathname, search, hash }} replace />;
}

const agentChatPath = (slug: string) => `/agents/${encodeURIComponent(slug)}/chat`;

/**
 * The playground became each agent's Chat tab. Without a slug in the path
 * (`?profile=` is the pre-slug form) it reopens the agent chatted with last.
 */
export function PlaygroundRedirect() {
	return (
		<MovedRoute
			to={({ agentSlug }, search) => {
				const slug = agentSlug ?? search.get("profile") ?? getLastChatAgent();
				return slug ? agentChatPath(slug) : "/agents";
			}}
		/>
	);
}
